import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IVideoResponseQuestionModelState,
  IVideoResponseResponseValidation,
  VideoResponseQuestionModelTypes
} from './types'

const VideoResponseQuestionModel: IQuestionModelConstructor<VideoResponseQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<VideoResponseQuestionModelTypes, IVideoResponseQuestionModelState>({
    questionType: QuestionType.VIDEO_RESPONSE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    namedFrames: 'none' != questionSchema.intro_type ? ['intro', 'question'] : ['question']
  })
  return model
}

function submitResponse({ response, questionSchema }: IVideoResponseQuestionModelState) {
  return response.uid != 'skip' ? [{ id: questionSchema.id, uid: response.uid }] : [{ id: questionSchema.id }]
}

function initState(state: IVideoResponseQuestionModelState): IVideoResponseQuestionModelState {
  state.response = { uid: null }
  return state
}

function validateResponse({
  response,
  frame,
  questionSchema
}: IVideoResponseQuestionModelState): IVideoResponseResponseValidation {
  return {
    valid:
      'intro' == frame && 'video' != questionSchema.intro_type
        ? true
        : /*'video' == response.mode && */ Boolean(response.uid)
  }
}

export default VideoResponseQuestionModel
